var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card-text',[_c('v-switch',{attrs:{"label":"Tylko zdjęcie","input-value":_vm.options.onlyPhoto},on:{"change":function($event){return _vm.update({onlyPhoto: $event})}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }